function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 17L21 19V20H3V19L5 17V11C5 7.65 7.36 4.85 10.5 4.17V3C10.5 2.17 11.17 1.5 12 1.5C12.83 1.5 13.5 2.17 13.5 3V4.17C16.64 4.85 19 7.65 19 11V17ZM13.99 21.01C13.99 22.11 13.1 23 12 23C10.9 23 10.01 22.11 10.01 21.01H13.99ZM11 16V14H13V16H11ZM11 8V12H13V8H11Z",
  fill: "#D64E0F"
});

var SvgIcAlertRecent = function SvgIcAlertRecent(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcAlertRecent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic-alert-recent.9e78ad1c.svg";
export { ForwardRef as ReactComponent };